import { render, staticRenderFns } from "./update-customer-dialog.vue?vue&type=template&id=2f0f6b2c&"
import script from "./update-customer-dialog.vue?vue&type=script&lang=js&"
export * from "./update-customer-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports